import { getImgUrl } from '@utils/functions/getImgUrl';
import moment from 'moment';
import Image from 'next/image';

const AuthorDetails = ({ name, designation, avatarImage, thumbnail, className, postedAt }) => {
  if (!name) return null;
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Image
        src={getImgUrl(avatarImage ?? thumbnail)}
        alt="icon"
        height={50}
        width={50}
        className="rounded-full object-cover"
      />
      <div className="flex flex-col items-start text-left font-satoshi-regular">
        <p className="font-satoshi-medium text-[14px] font-semibold leading-5">{name}</p>
        {designation && (
          <p className="font-satoshi-medium text-[14px] font-light capitalize leading-5 text-[#A3A3A3] line-clamp-1">
            {designation} at almaBetter
          </p>
        )}
        {postedAt && (
          <p className="font-satoshi-medium text-[14px] font-light capitalize leading-5 text-[#646464] line-clamp-1">
            {moment(postedAt).format('DD MMM YYYY')}
          </p>
        )}
      </div>
    </div>
  );
};

export default AuthorDetails;
